export default __webpack_public_path__ + "static/media/480_store03-nl-mobile.49cb39cc.png";